module.exports = __webpack_public_path__ + "img/logo-sud.d18a2da6.jpeg";